import React, { useState } from 'react';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getAutocompleteCtepIdApi } from 'actions/packet';
import { getAdminCirbInstitutionApi } from 'actions/admin/AdminCirbPrefsActions';
import TypeAhead from './TypeAhead';

export const getSignOptions = (resp) => {
  let opts = [];
  const { response } = resp;
  if (response != null && response.length > 0) {
    const level2Nodes = response[0][`level${2}_nodes`];
    if (level2Nodes && level2Nodes[0]) {
      opts = level2Nodes
        .map(({ level3_nodes: level3Nodes }) => (level3Nodes
          ? level3Nodes.map((r) => {
            const { ctep_id: ctepId, node_label: label } = r;
            const arrLab = label.split(':');
            arrLab.splice(1, 1);
            const dispalyName = arrLab.join(' - ');
            return {
              label: dispalyName,
              value: ctepId,
              siteName: dispalyName
            };
          })
          : []))
        .flat();
    }
  }
  return opts;
};

function InstitutionTypeAhead({
  context, onChange, value, ariaText, isDisabled = false, signatoryCtepId, ognType
}) {
  const [options, setOptions] = useState([]);

  const getInstAutoComplete = (searchText) => {
    bindLogger(
      getAutocompleteCtepIdApi,
      context
    )(searchText)().subscribe((resp) => {
      const { response } = resp;
      if (response != null && response.length > 0) {
        const opts = [];
        response.forEach((r) => {
          const { siteCtepId, siteName } = r;
          if (r.siteCtepId.toUpperCase().includes(ognType) || r.siteCtepId === searchText.toUpperCase()) {
            opts.push({
              label: `${siteCtepId} - ${siteName}`,
              value: siteCtepId,
              siteName
            });
          }
        });
        setOptions(opts);
      }
    });
  };

  const getBySigIdAutoComplete = () => {
    bindLogger(
      getAdminCirbInstitutionApi,
      context
    )(signatoryCtepId)().subscribe((resp) => {
      const opts = getSignOptions(resp);
      setOptions(opts);
    });
  };

  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setOptions([]);
      return;
    }
    if (signatoryCtepId) {
      getBySigIdAutoComplete();
    } else {
      getInstAutoComplete(searchText);
    }
  };

  return (
    <TypeAhead
      name="Institution"
      ariaText={ariaText}
      value={value}
      options={options}
      onChange={onChange}
      onChangeText={fetchOptions}
      isDisabled={isDisabled}
    />
  );
}

export default withAppContext(InstitutionTypeAhead);
